export default __webpack_public_path__ + "static/media/Vectorverified.7078066c.svg";